import React, { useRef, useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useField } from '@unform/core';
import ReactTooltip from 'react-tooltip';
import { FaExclamationCircle, FaEye, FaEyeSlash } from 'react-icons/fa';

import { Container, Error } from './styles';

const Input = ({
  name,
  label,
  className,
  visible,
  icon: Icon,
  color,
  type,
  ...rest
}) => {
  const { fieldName, registerField, defaultValue, error } = useField(name);
  const inputRef = useRef(null);

  const [isFocused, setIsFocused] = useState(false);
  const [isFilled, setIsFilled] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
    setIsFilled(!!inputRef.current?.value);
  }, []);
  const togglePasswordVisibility = useCallback(() => {
    setShowPassword(prev => !prev);
  }, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <Container
      className={className}
      visible={visible}
      isErrored={!!error}
      isFilled={isFilled}
      isFocused={isFocused}
      color={color}
    >
      <label>{label}</label>
      {Icon && <Icon size={20} />}
      <input
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        defaultValue={defaultValue}
        ref={inputRef}
        type={type === 'password' ? (showPassword ? 'text' : 'password') : type}
        {...rest}
      />

      {type === 'password' &&
        (showPassword ? (
          <FaEyeSlash
            size={20}
            className="visibility-toggle"
            role="button"
            tabIndex={0}
            aria-label="Ocultar senha"
            onClick={togglePasswordVisibility}
            onKeyDown={e => e.key === 'Enter' && togglePasswordVisibility()}
          />
        ) : (
          <FaEye
            size={20}
            className="visibility-toggle"
            role="button"
            tabIndex={0}
            aria-label="Mostrar senha"
            onClick={togglePasswordVisibility}
            onKeyDown={e => e.key === 'Enter' && togglePasswordVisibility()}
          />
        ))}

      {error && (
        <Error isFilled={isFilled} isFocused={isFocused}>
          <ReactTooltip place="top" effect="solid" backgroundColor="#e53935" />
          <FaExclamationCircle color="#E53935" size={16} data-tip={error} />
        </Error>
      )}
    </Container>
  );
};

export default Input;

Input.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
  visible: PropTypes.bool,
  icon: PropTypes.func,
  color: PropTypes.string,
};

Input.defaultProps = {
  label: null,
  className: null,
  visible: true,
  icon: null,
  color: '#01579b',
};
